import React from 'react';
import styled from 'styled-components';
import { useRef } from 'react';
import ThumbnailImg from './ThumbnailImg';
import { useState } from 'react';
import { useEffect } from 'react';
import { isMobileOnly } from 'react-device-detect';

const ThumbnailSliderBlock = styled.div`
    overflow: hidden; // 선을 넘어간 이미지들은 보이지 않도록 처리 
`;

const ThumbnailSliderPrevBtnBlock = styled.button`
    width: 75px;
    height: 31px;
    position: absolute;
    display: ${props => props.isShow};
    background-image:url(${props => props.img});
    ${isMobileOnly&&`
        transform: rotate(-90deg);
        top: 22px;
        left: -19px;        
    `};
    // &:hover {
    //     transition: all 0.3s ease-in-out;
    //     background-color: #e0e0e0;
    //     color: #fff;
    // }
`;

const ThumbnailSliderNextBtnBlock = styled.button`
    width: 75px;
    height: 31px;
    position: absolute;
    background-image:url(${props => props.img});
    display: ${props => props.isShow};
    
    ${isMobileOnly?`
        right: -23px;
        top: 21px;
        transform: rotate(-90deg);        
    `:`
        margin: -40px 0px 0px 0px;        
    `};
    // &:hover {
    //     transition: all 0.3s ease-in-out;
    //     background-color: #e0e0e0;
    //     color: #fff;
    // }
`;

const ThumbnailSliderContainer = styled.div`
    width: ${isMobileOnly?'1176px':'100%'};
    ${isMobileOnly&&`display:flex`};
`;

const ThumbnailSlider = ({ imglist, display_num, mouseover }) => {

    const [startSlide, setStartSlide] = useState(0);
    const [dispSlide, setDispSlide] = useState([]);
    const slideRef = useRef(null);
    var keyid = 0;

    // console.log("imglist : " + JSON.stringify(imglist));

    useEffect(() => {
        if (imglist != null && imglist.length > display_num) {
            setDispSlide(imglist.slice(startSlide, startSlide + display_num));
        } else {
            setDispSlide(imglist);
        }
    }, [imglist, startSlide])

    if (dispSlide.length === 0) {
        return <ThumbnailSliderBlock />;
    } else {
        // console.log("dispSlide : " + JSON.stringify(dispSlide));
    }

    const handleMoueOver = (imginfo) => {
        mouseover(imginfo);
    }

    const handlePrevClick = () => {
        setStartSlide(startSlide - 1)
    }

    const handleNextClick = () => {
        setStartSlide(startSlide + 1)
    }

    return (
        <ThumbnailSliderBlock>
            <ThumbnailSliderPrevBtnBlock
                img={"/assets/images/icon/pd_thumb_arrow-icon-up.png"}
                isShow={startSlide > 0 ? 'block' : 'none'}
                onClick={handlePrevClick} />
            <ThumbnailSliderContainer ref={slideRef}>
                {
                    dispSlide.map(function (imginfo) {
                        return (
                            <ThumbnailImg key={keyid++}
                                img={imginfo}
                                width="75" height="75"
                                mouseover={handleMoueOver}
                                onClick={handleMoueOver}
                            />
                        );
                    }
                    )
                }
            </ThumbnailSliderContainer>
            <ThumbnailSliderNextBtnBlock
                img={"/assets/images/icon/pd_thumb_arrow-icon.png"}
                isShow={(startSlide + display_num) < imglist.length ? 'block' : 'none'}
                onClick={handleNextClick} />
        </ThumbnailSliderBlock>
    );
};




export default ThumbnailSlider;
